/* ============================================================
   EPICKA 自定义导航脚本(Mega Menu 悬停切换 + 手机端展开/收起)
   ▶ 与旧版功能完全一致,但不再需要 jQuery,少搬一个文件、少一个坑
   维护说明:此文件独立于主题,主题更新时整个文件原样搬入新主题 Assets
   ============================================================ */

(function () {
    function initEpickaMegaMenu() {
        /* ---------- 1. 初始化:让默认高亮的左侧菜单对应的右侧内容显示出来 ----------
           隐藏了二级列表的菜单(new-mega-menu--no-subnav)不在这里处理:
           它没有二级切换,面板显隐交给 CSS 的 :first-child 规则,JS 别去设内联样式 */
        document.querySelectorAll('.new-mega-menu-nav-active').forEach(function (el) {
            if (el.closest('.new-mega-menu--no-subnav')) return;

            var target = el.getAttribute('targetnav');
            var panel = target ? document.getElementById(target) : null;
            if (panel) panel.style.display = 'block';
        });

        /* ---------- 2. PC 端:鼠标悬停左侧菜单 → 切换右侧内容 ----------
           隐藏了二级列表的菜单没有可点的左侧菜单,直接跳过绑定 */
        document.querySelectorAll('.new-mega-menu-sublink').forEach(function (item) {
            if (item.closest('.new-mega-menu--no-subnav')) return;

            item.addEventListener('mouseenter', function () {
                // 同组菜单全部取消高亮,再高亮当前项
                var nav = item.closest('.new-mega-menu__nav');
                if (nav) {
                    nav.querySelectorAll('.new-mega-menu-sublink').forEach(function (s) {
                        s.classList.remove('new-mega-menu-nav-active');
                    });
                }
                item.classList.add('new-mega-menu-nav-active');

                // 右侧所有内容先隐藏
                var left = item.closest('.new-mega-menu-left');
                var right = left ? left.nextElementSibling : null;
                if (right && right.classList.contains('new-mega-menu-right')) {
                    right.querySelectorAll('.new-mega-menu-content').forEach(function (c) {
                        c.style.display = 'none';
                    });
                }

                // 显示当前项对应的内容
                var target = item.getAttribute('targetnav');
                var panel = target ? document.getElementById(target) : null;
                if (panel) panel.style.display = 'block';
            });
        });

        /* ---------- 3. 手机端:点击标题 → 展开/收起图片列表 ---------- */
        document.querySelectorAll('.new-mega-menu-expand-and-collapse-button').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var content = btn.nextElementSibling;
                if (!content || !content.classList.contains('new-mega-menu-expand-and-collapse-content')) return;

                var svg = btn.querySelector('svg');
                var isHidden = window.getComputedStyle(content).display === 'none';

                if (isHidden) {
                    content.style.display = 'block';
                    if (svg) svg.style.transform = 'rotate(90deg)';
                } else {
                    content.style.display = 'none';
                    if (svg) svg.style.transform = 'rotate(0deg)';
                }
            });
        });
    }

    // 页面加载完成后启动(无论脚本放在头部还是尾部都能正常工作)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initEpickaMegaMenu);
    } else {
        initEpickaMegaMenu();
    }
})();